var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 119,
    viewBox: "0 0 100 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 119,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -863,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518399,
    d: "M11.1779 112.458L0.44242 138.941L-36.3973 124.008C-59.1399 114.789 -70.1947 88.9041 -61.0304 66.2966C-51.8662 43.6891 -25.9079 32.808 -3.16534 42.027L33.6744 56.9604L22.939 83.444L-13.9008 68.5105C-21.9556 65.2454 -31.1451 69.1047 -34.3851 77.0976C-37.6257 85.0919 -33.7167 94.2593 -25.6619 97.5244L11.1779 112.458Z",
    fill: "#F2994A",
    stroke: "#111111",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.571826,
    d: "M2.15268 2.37118C14.3612 2.46988 26.4458 4.87622 37.7681 9.46813C49.5539 14.248 60.2828 21.3025 69.3422 30.2288C78.4017 39.1551 85.6142 49.7783 90.5682 61.492C95.522 73.2057 98.1203 85.7805 98.2144 98.4983C98.3086 111.216 95.8969 123.828 91.117 135.614C86.3371 147.4 79.2826 158.128 70.3563 167.188C61.43 176.247 50.8068 183.46 39.0931 188.414C27.8401 193.173 15.7924 195.758 3.58667 196.037L3.36965 166.728C11.7267 166.48 19.9698 164.683 27.6782 161.423C35.8474 157.968 43.2561 152.938 49.4813 146.62C55.7065 140.302 60.6264 132.819 63.9599 124.6C67.2934 116.38 68.9754 107.585 68.9097 98.7153C68.844 89.8458 67.032 81.0761 63.5771 72.9069C60.1223 64.7377 55.0922 57.329 48.7741 51.1038C42.456 44.8786 34.9736 39.9587 26.7541 36.6252C18.9983 33.4797 10.7295 31.8047 2.3697 31.681L2.15268 2.37118Z",
    fill: "#27AE60",
    stroke: "#111111",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: 752,
    y1: -863,
    x2: 752,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -863,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube2);
export default __webpack_public_path__ + "static/media/Tube2.d84e188e31970b5bdc3a6010225d0221.svg";
export { ForwardRef as ReactComponent };